module.exports = __webpack_public_path__ + "img/dept_7_sales2.2a703fdc.png";